<template>
    <div class="user-presentation-card">
        <div class="image" :class="{'mr-0' : !withInfo }">
            <img class="avatar" :src="user.avatar" :alt="user.name">
        </div>
        <div class="info" v-if="withInfo">
            <h6 v-text="user.name"></h6>
            <div v-if="ate" class="ate" v-text="user.employer_number"></div>
            <div v-if="att" class="att" v-text="user.att_number"></div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            user: {
                type: Object,
                required: true,
            },
            withInfo:{
                type: Boolean,
                required: false,
                default: true,
            },
            ate: {
                type: Boolean,
                required: false,
                default: true,
            },
            att: {
                type: Boolean,
                required: false,
                default: true,
            }
        }
    }
</script>